const ERROR_TYPE = {
  network: "Network error",
  client: "Client side error",
  server: "Server side error"
};
export default ERROR_TYPE;
